// extracted by mini-css-extract-plugin
module.exports = {"StudentListContainer":"StudentList_StudentListContainer__3DCGr","StudentList":"StudentList_StudentList__3c5hY"};